module.exports = __webpack_public_path__ + "img/not-data.429b806a.svg";